<template lang="pug">
  NuxtLink.tournament-card.phased-tournament-card(
    :class="{ '--list-item': view === 'list', '--big': view === 'big', '--cell': view === 'cells', '--small': view === 'list' && isSmall }"
    :to="localeLocation(`/${game.name}/phased-tournaments/${tournament.id}`)"
  )
    .tournament-card__body
      .tournament-card__image
        img(v-if="tournamentImage" :src="tournamentImage" :alt="tournament.title" v-lazy-load)

        .tournament-card__status(:class="statusClass")
          img(:src="require('~/assets/img/icons/status.svg')" alt="status")
          span {{ statusText }}

        .tournament-card__freeroll(v-if="!isTournamentSponsored && isFreeroll") Freeroll

        TournamentCardLabels(v-if="view === 'cells'" :labels="labels")

      .tournament-card__content
        .tournament-card__content-top
          .tournament-card__info
            .tournament-card__date
              span {{ $t('timeAndDate', { date, time }) }}
              span ·
              span {{ game.extra_data.title }}
            .tournament-card__title
              | {{ tournament.title }}
              .tournament-card__youtube(v-if="youtubeLink")
                img(:src="require('~/assets/img/icons/youtube.svg')" alt="youtube")
                | {{ $t('streamButton') }}
              .tournament-card__twitch(v-if="twitchLink")
                img(:src="require('~/assets/img/icons/twitch.svg')" alt="twitch")
                | {{ $t('streamButton2') }}

          .tournament-card__players(v-if="view === 'list' && players.length")
            .caption
              | {{ $t('membersCount') }}:&nbsp;
              strong {{ tournament.players_count }}

        TournamentCardLabels(v-if="view !== 'cells' && !isSmall" :labels="labels")

        .tournament-card__players(v-if="view !== 'list'")
          .caption(v-if="players.length")
            | {{ $t('membersCount') }}&nbsp;
            strong {{ tournament.players_count }}

          .caption(v-else)
            | {{ $t('noParticipants') }}

          Button(is-primary).tournament-card__participant-link
            | {{ $t('participate') }}

    TournamentCardLabels(v-if="view === 'list' && isSmall" :labels="labels")
</template>

<script>
import TournamentCard from '~/components/TournamentCard/TournamentCard'

export default {
  name: 'PhasedTouranmentCard',

  extends: TournamentCard,

  computed: {
    tournamentImage () {
      return this.tournament?.image_url
    }
  }
}
</script>

<style lang="scss">
.tournament-card {
  &__participant-link {
    @media (max-width: $breakpointMobile) {
      padding: 7px 14px !important;
    }
  }

  &__content-top {
    display: flex;
    justify-content: space-between;
  }

  &__banner {
    max-width: 130px;
    margin-top: 24px;
    margin-right: 22px;

    img {
      width: 130px;
      height: fit-content;
    }

    @media (max-width: $breakpointMobile) {
      max-width: 90px;
      margin-top: 14px;

      img {
        width: 90px;
        height: auto;
      }
    }
  }
}
</style>
